// extracted by mini-css-extract-plugin
export default {"AutoChoiceRadio":"targetTypeSelection_AutoChoiceRadio__GT5OG"};